<template>
  <div v-if="masterCampaign">
    <vx-card>
      <vs-row vs-justify="space-between">
        <vs-col vs-w="6">
          <h3 class="mr-4">Campaigns to be sent</h3>
          <p class="mt-5">
            By clicking the button above, the following approved campaigns will
            be sent at their designated times
          </p>
        </vs-col>
      </vs-row>

      <div class="data-list-container data-list-list-view">
        <vs-table
          ref="table"
          class="mt-8"
          maxItems="10"
          v-model="selected"
          pagination
          search
          :data="approvedCampaigns"
          @selected="onClicked(selected.id)"
        >
          <template slot="thead">
            <vs-th sort-key="venueName">Venue name</vs-th>
            <vs-th sort-key="status">Status</vs-th>
            <vs-th sort-key="approvedByDate">VM fill out by</vs-th>
            <vs-th sort-key="sendEmailDate" v-if="masterCampaign.hasEmail"
              >Send Email date</vs-th
            >
            <vs-th sort-key="sendSmsDate" v-if="masterCampaign.hasSms"
              >Send Sms date</vs-th
            >
            <vs-th sort-key="sendNpPushDate" v-if="masterCampaign.hasNpPush"
              >Send NightPay push date</vs-th
            >
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <p class="product-name font-medium truncate">
                    {{ tr.venueName }}
                  </p>
                </vs-td>
                <vs-td :key="tr.status">
                  <vs-chip
                    :color="statusObject(tr.status).color"
                    class="product-order-status"
                  >
                    {{ statusObject(tr.status).text }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ tr.approvedByDate | date(true) }}
                  </p>
                </vs-td>
                <vs-td v-if="masterCampaign.hasEmail">
                  <vs-chip
                    color="danger"
                    v-if="
                      isDateLateForActiveMaster(tr.sendEmailDate) &&
                      !tr.hasSentEmail
                    "
                  >
                    {{ tr.sendEmailDate | formatDate }}
                  </vs-chip>
                  <p v-else>
                    {{ tr.sendEmailDate | formatDate }}
                  </p>
                </vs-td>
                <vs-td v-if="masterCampaign.hasSms">
                  <vs-chip
                    color="danger"
                    v-if="
                      isDateLateForActiveMaster(tr.sendSmsDate) &&
                      !tr.hasSentSms
                    "
                  >
                    {{ tr.sendSmsDate | formatDate }}
                  </vs-chip>
                  <p v-else>
                    {{ tr.sendSmsDate | formatDate }}
                  </p>
                </vs-td>
                <vs-td v-if="masterCampaign.hasNpPush">
                  <vs-chip
                    color="danger"
                    v-if="
                      isDateLateForActiveMaster(tr.sendNpPushDate) &&
                      !tr.hasSentNpPush
                    "
                  >
                    {{ tr.sendNpPushDate | formatDate }}
                  </vs-chip>
                  <p v-else>
                    {{ tr.sendNpPushDate | formatDate }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <preview-popup ref="previewPopup" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";
import PreviewPopup from "./PreviewCampaignPopup.vue";

export default {
  components: { PreviewPopup },
  mixins: [campaignMixin],
  props: ["masterCampaign"],
  data() {
    return {
      moment,
      selected: [],
      popupActive: false,
      popupCampaign: null,
    };
  },
  methods: {
    async onClicked(id) {
      await this.$store.dispatch("venueCampaigns/get", id);
      this.$refs.previewPopup.show(
        this.venueCampaign,
        this.masterCampaign,
        true
      );
    },

    isDateLateForActiveMaster(date) {
      return (
        this.masterCampaign.masterStatus == "Active" &&
        moment(date).isBefore(moment())
      );
    },
  },
  computed: {
    ...mapGetters({
      venueCampaigns: "venueCampaigns/masterVenueCampaigns",
      venueCampaign: "venueCampaigns/venueCampaign",
    }),
    approvedCampaigns() {
      return this.venueCampaigns.filter(
        (e) =>
          e.status == "Approved" ||
          e.status == "PartiallySent" ||
          e.status == "Sent" ||
          e.status == "ErrorSending" ||
          e.hasSentEmail ||
          e.hasSentSms ||
          e.hasSentNpPush
      );
    },
  },

  async created() {
    console.log("Getting for id", this.masterCampaign.id);
    await this.$store.dispatch(
      "venueCampaigns/getForMasterCampaign",
      this.masterCampaign.id
    );
  },
};
</script>

<style lang="scss">
</style>
